import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserType } from '../consts/types/general';
import { ReduxState } from "../consts/types/store";


/** State */
export interface AuthState {
    userType?:UserType;
}


/** Selectors */
export const AuthSelectors = {
    currentUserType: (state: ReduxState) => state.auth.userType,
    

}


/** Reducer */

const initialState: AuthState = {
    
}

const authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        setUserType(state, action: PayloadAction<{ type?: UserType }>) {
            state.userType = action.payload.type;
        },
       

    }
})

export const authActionsCreators = authSlice.actions;
export default authSlice.reducer